import React, { useState } from 'react';
import { Button } from '../../ui/Button';
import { Alert } from '../../ui/Alert';

export const PermanentDeleteModal = ({ moment, onConfirm, onClose }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const confirm = async () => {
    setBusy(true);
    setError('');
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message || 'Could not delete this moment. Nothing was removed; please try again.');
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4">
      <div className="bg-white w-full max-w-sm rounded-3xl p-6 space-y-4 shadow-xl">
        <h2 className="text-xl font-bold text-slate-900 tracking-tight">Delete permanently?</h2>
        <p className="text-sm text-slate-600">
          <span className="font-bold">{moment.title || 'This moment'}</span>, its notes and its photos, recordings and files will be deleted forever. This cannot be undone. The people linked to it are not deleted.
        </p>
        {error && <Alert variant="error" message={error} />}
        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button variant="danger" onClick={confirm} isLoading={busy}>Delete permanently</Button>
        </div>
      </div>
    </div>
  );
};